<template>
  <div class="lang">
    <main>
      <nav>
        <a href="https://figma.cool" target="_blank" class="logo">
          <img src="../assets/fc-logo.svg" alt="fc-logo" />
          <p>Figma 界面中英词条集</p>
        </a>
        <a class="button" href="https://figma.cool" target="_blank">👉 Figma.Cool</a>
      </nav>
      <h1>Figma 界面中英<br>词条集</h1>
      <div class="iframe">
        <iframe
          src="https://quizlet.com/514427420/flashcards/embed?i=w3aui&x=1jj1"
          height="500"
          width="100%"
          style="border:0"
        ></iframe>
      </div>
      <div class="row" v-for="(item, index) in this.cnData" :key="index">
        <div class="value">{{item[0]}}</div>
        <div class="key">{{item[1]}}</div>
      </div>
    </main>
  </div>
</template>

<script>
import allData from '../content.js'

export default {
  name: 'lang',
  components: {
  },
  data () {
    return {
      cnData: allData
    }
  }
}
</script>

<style lang="scss" scoped>
.lang {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  text-align: left;
  color: #3e4373;

  main {
    width: 100%;
    max-width: 780px;
    margin-bottom: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h1 {
    display: none;
  }

  nav {
    z-index: 99;
    width: 100vw;
    position: fixed;
    padding: 24px 20px;
    left: 0;
    top: 0;
    display: flex;
    justify-content: space-between;
    background: white;

    .logo {
      display: flex;
      align-items: center;

      img {
        margin-right: 16px;
      }

      p {
        font-size: 18px;
        line-height: 18px;
        padding: 8px 20px;
        border-left: 1px solid hsl(0, 0%, 90%);
      }
    }

    .button {
      border: none;
      background: #50b4f9;
      padding: 12px 16px;
      border-radius: 12px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.015em;
      color: white;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .iframe {
    width: 100%;
    margin: 160px 0 120px 0;
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 1px 3px rgba(62, 67, 115, 0.3);
    border-radius: 12px;

    iframe {
      border-radius: 6px;
    }
  }

  .row {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    margin-top: -1px;
    font-size: 16px;
    line-height: 22px;

    &:hover {
      background: hsl(240, 6%, 95%) !important;
    }

    &:nth-of-type(2n) {
      background: #fafafb;
    }

    .value,
    .key {
      padding: 12px;
    }

    .value {
      width: 60%;
      border-right: none;
    }

    .key {
      width: 40%;
      margin-left: -1px;
      border-left: none;
    }
  }

  @media screen and(max-width: 600px) {
    main {
      padding: 0 20px;

      nav {
        padding: 12px 16px;

        .logo p {
          display: none;
        }

        .button {
          transform-origin: top right;
          transform: scale(0.8);
        }
      }

      h1 {
        display: inline-block;
        margin: 140px 0 0 0;
        font-size: 40px;
        line-height: 50px;
        font-weight: 700;
        text-align: center;
      }

      .iframe {
        margin: 90px 0 60px 0;
      }
    }
  }
}
</style>
